<div class="wrapper">
  <div class="grid-container margin-top">
    <div class="bold">
      <h4>Select Document Group And Document Type:</h4>
    </div>
    <div class="grid-x">
      <div class="cell large-12 margin-right">
        <div class="bold">
          *Document Group:
        </div>
        <div>
          @if (documentGroups.length !== 1) {
            <ng-select  [(ngModel)]="selectedDocumentGroup" [items]="documentGroups" bindLabel="name" placeholder=""
            (change)="docGroupSelected($event)"></ng-select>
          }
        </div>
        <div>
          <text-loader [run]="documentGroups.length === 1" [text]="'Loading Document Groups'" [tickType]="'.'" [interval]="2000"></text-loader>
        </div>
      </div>
      <div class="cell large-12">
        <div class="bold">
          *Document Type:
        </div>
        @if (!loadingDocTypes) {
          <ng-select [(ngModel)]="selectedDocumentType" [items]="filteredDocTypes()" bindLabel="name" placeholder=""
          (change)="docTypeSelected($event)"></ng-select>
        }
        @if ((!this.selectedDocumentType || this.selectedDocumentType.id == -1) && !loadingDocTypes) {
          <div class="error-container">
            @if (!validDocumentTypeSelected()) {
              <small class="error">
                Please select a valid document group and type.
              </small>
            }
          </div>
        }
        <text-loader [run]="loadingDocTypes" [text]="'Loading Document Types'" [tickType]="'.'" [interval]="2000"></text-loader>
      </div>
    </div>
    <hr>
      @if (ricsOrgIdToSearchFor == '' && legacyOrgIdToSearchFor == ''&& partialOrgNameToSearchFor == '') {
        <div>
          <div class="bold">
            <h4>Search for a well to tie this document to:</h4>
          </div>
          <div class="grid-x">
            <div class="cell large-2 bold">
              API Number:
            </div>
            <div class="cell large-3 margin-right">
              <input type="text" [(ngModel)]="apiToSearchFor">
            </div>
            <div class="cell large-2 margin-right">
              <button class="button hollow minor-margin-right" (click)="getWell()">Search for the Well</button>
            </div>
          </div>
        </div>
      }
      <hr>
        @if (apiToSearchFor == '') {
          <div>
            <div class="bold">
              <h4>Search for an organization to tie this document to:</h4>
            </div>
            @if (legacyOrgIdToSearchFor == '' && ricsOrgIdToSearchFor == '') {
              <div class="grid-x">
                <div class="cell large-2 bold">
                  Owner Name:
                </div>
                <div class="cell large-3 margin-right">
                  <ng-select #nameSearchSelect [(ngModel)]="relatedOrg" [items]="matchingOrgs" bindLabel="name" [placeholder]="" appendTo="body" (change)="onPartialOrgNameChange($event)" (search)="setPartialOrgNameToSearchFor($event)" ></ng-select>
                </div>
                <div class="cell large-3 margin-right">
                  <button class="button hollow minor-margin-right" (click)="getOrgByPartialName()">Search for any matching Orgs</button>
                </div>
                <hr>
                </div>
              }
              @if (legacyOrgIdToSearchFor == '' && partialOrgNameToSearchFor == '') {
                <div class="grid-x">
                  <div class="cell large-2 bold">
                    RICS Owner Number:
                  </div>
                  <div class="cell large-3 margin-right">
                    <input type="text" [(ngModel)]="ricsOrgIdToSearchFor">
                  </div>
                  <div class="cell large-2 margin-right">
                    <button class="button hollow minor-margin-right" (click)="getOrgFromRicsOrgId()">Search for the Org</button>
                  </div>
                  <hr>
                  </div>
                }
                @if (ricsOrgIdToSearchFor == '' && partialOrgNameToSearchFor == '') {
                  <div class="grid-x">
                    <div class="cell large-2 bold">
                      RBDMS Owner Number:
                    </div>
                    <div class="cell large-3 margin-right">
                      <input type="text" [(ngModel)]="legacyOrgIdToSearchFor">
                    </div>
                    <div class="cell large-2 margin-right">
                      <button class="button hollow minor-margin-right" (click)="getOrgFromRbdmsOrgId()">Search for the Org</button>
                    </div>
                  </div>
                }
                <hr>
                </div>
              }
              <form [formGroup]="mappedKeywordsForm">
                @if (!loadingKeywordMappings) {
                  @if ((relatedWell || relatedOrg) && selectedDocumentType.name != '-- Select a Document Type --') {
                    <div class="bold">
                      <h4>Keywords Populated From Relevant Entity:</h4>
                      <div class="grid-x">
                        @for (mappedKeyWord of mappedKeyWordsWithEntityMaps; track mappedKeyWord) {
                          <div class="cell large-5 margin-right">
                            <onbase-mapped-keyword-input [parentFormGroup]="mappedKeywordsForm" [mappedKeyWord]="mappedKeyWord" [entity]="getRelevantEntity()" (keywordValueUpdated)="onKeywordValueUpdated()" [isDisabled]="keywordIsDisabled(mappedKeyWord.name)"></onbase-mapped-keyword-input>
                          </div>
                        }
                      </div>
                      <hr>
                      </div>
                    }
                    @if (mappedKeyWordsRequired.length > 0) {
                      <div class="bold">
                        <h4>Required Keywords:</h4>
                        <div class="grid-x">
                          @for (mappedKeyWord of mappedKeyWordsRequired; track mappedKeyWord) {
                            <div class="cell large-5 margin-right">
                              <onbase-mapped-keyword-input [parentFormGroup]="mappedKeywordsForm" [mappedKeyWord]="mappedKeyWord" (keywordValueUpdated)="onKeywordValueUpdated()" [isDisabled]="keywordIsDisabled(mappedKeyWord.name)"></onbase-mapped-keyword-input>
                            </div>
                          }
                        </div>
                        <hr>
                        </div>
                      }
                      <accordion>
                        <accordion-panel>
                          <div panel-header><h4>Optional Keywords:</h4></div>
                          @if (mappedKeyWordsOptional.length > 0) {
                            <div class="bold">
                              <div class="grid-x">
                                @for (mappedKeyWord of mappedKeyWordsOptional; track mappedKeyWord) {
                                  <div class="cell large-5 margin-right">
                                    <onbase-mapped-keyword-input [parentFormGroup]="mappedKeywordsForm" [mappedKeyWord]="mappedKeyWord" (keywordValueUpdated)="onKeywordValueUpdated()" [isDisabled]="keywordIsDisabled(mappedKeyWord.name)"></onbase-mapped-keyword-input>
                                  </div>
                                }
                              </div>
                              <hr>
                              </div>
                            }
                          </accordion-panel>
                        </accordion>
                      } @else {
                        <div class="grid-x">
                          <div class="large-12 medium-12 small-12">
                            <text-loader [run]="loadingKeywordMappings" [text]="'Loading Keyword Mappings'" [tickType]="'.'" [interval]="2000"></text-loader>
                          </div>
                        </div>
                      }
                      <div class="cell large-12">
                        Documentation To Upload<span [ngClass]="{ 'red': mappedKeywordsForm.get('uploadedFile').invalid, 'bold': mappedKeywordsForm.get('uploadedFile').invalid }"></span>:
                      </div>
                      <div class="cell large-12 minor-margin-bottom">
                        <upload-view-files [isPadded]="false" (newFilesList)="savedFiles($event)"></upload-view-files>
                        @if (hasFileListing) {
                          <div class="file-list padding-all-small">
                            <h3 class="minor-margin-bottom h6">Uploaded Files</h3>
                            @for (file of uploadedFiles; track file) {
                              <div class="flex">
                                <uploaded-file [allowFileDeletion]="!uploadComplete" [file]="file" (fileDeleted)="deleteFile($event)"></uploaded-file>
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <div class="grid-x">
                        <div class="cell large-4 text-align-center"><button class="button" [attr.disabled]="hasFileListing && keywordsLoaded?.value && mappedKeywordsForm.valid? null : 'disabled'" (click)="onSubmitClick()">Submit</button></div>
                        <div class="cell large-4 text-align-center"><button class="button" (click)="onReturnClick()">Return to the dashboard</button></div>
                        <div class="cell large-4 text-align-center"><button class="button" [attr.disabled]="hasFileListing && keywordsLoaded?.value && mappedKeywordsForm.valid? null : 'disabled'" (click)="onSubmitAndAddAnotherClick()">Submit & Add Another</button></div>
                      </div>
                    </form>
                  </div>
                </div>

